export default __webpack_public_path__ + "static/media/76-desktop.d9d94146.jpg";